module.exports = __webpack_public_path__ + "scripts/media/live_events.ca6a413b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live_events.svg
// module id = 7038
// module chunks = 0